<template>
	<div class="box">
		<div>
			<el-row>
				<el-col :span="4" class="accordBox1" style="width: 11%">
					<el-collapse accordion v-for="(item,indexel) in left_title" :key="indexel">
						<el-collapse-item>
							<template slot="title">
								<span>{{item.title}}</span>
							</template>
							<div class="panel-body">
								<div class="tabs" style="border-left: 2px solid rgb(237, 237, 237);">
									<div v-for="(data,index) in item.jiaoan" @click="tabbar(index,data.id)" class="kelist hang1"
										:class="{active2:tab_index == index}">
										{{data.name}}
									</div>
								</div>
							</div>
						</el-collapse-item>
					</el-collapse>
				</el-col>

				<!--第一节-->
				<el-col :span="24" style="width: 88%;padding-left: 15px;">
					<div class="conTitle text-center contentbox">
						<p style="position: absolute; left: 35%;">
							<span style="font-size: 22px;">{{list_zong.titl}}</span>
							<span style="color: rgb(153, 153, 153); font-size: 12px;">(<span>{{list_zong.title}}</span>)</span>
						</p>
						<div style="float: right;">
							<span class="titletier"><span style="color: rgb(102, 102, 102);">课程时长：</span> <span>{{list_zong.kcsc}}</span>分钟</span>
							<span class="titletier">
								<span style="color: rgb(102, 102, 102);">课程课时：</span> <span>第 <span>{{list_zong.qishu}}</span> 课时</span>
							</span>
							<span class="titletier"><span style="color: rgb(102, 102, 102);">课程级别：</span>{{list_zong.kcjb}}<span></span></span>
						</div>
					</div>

					<el-row>
						<el-col :span="24">
							<div class="zhengwen">
								<div class="fix">
									<p class="title11">教学目标</p>
								</div>
								<div class="neirong11">
									<p style="text-indent:0">
										<span v-html="list_zong.jxmb" style="font-family:微软雅黑;color:rgb(0,0,0);font-size:15px"></span>
									</p>
								</div>
							</div>

							<div class="zhengwen">
								<div class="fix">
									<p class="title11">重点难点</p>
								</div>
								<div class="neirong11">
									<p style="text-indent:0">
										<span v-html="list_zong.zdnd" style="font-family:微软雅黑;color:rgb(0,0,0);font-size:15px"></span>
									</p>
								</div>
							</div>

						</el-col>
					</el-row>

					<el-row style="margin-bottom: 4px">
						<el-col :span="24">
							<div class="zhengwen" v-for="(item,index) in list_fen">
								<div class="fix">
									<div class="title11" v-if="item.process != ''">
										<span style="font-weight: bold;">
											{{index+1}}. {{item.title ? item.title : '暂无'}}
										</span>
					                    <span style="float: right;margin-right: 90px;">音乐播放</span>
										<span @click="play_music(item.process_audio)" class="fa fa-music"></span>
										<span style="float: right;margin-right: 80px;">视频演示</span>
										<span @click="play_video(item.process_video)" class="fa fa-play-circle"></span>
									</div>
									<p style="padding: 15px 0 5px;text-align: center;" v-else>暂无数据</p>
								</div>
								<div class="neirong11" v-html="item.process"></div>
							</div>
						</el-col>
					</el-row>
					<el-dialog
					  :visible.sync="music_dialogVisible"
					  top="30vh"
					  width="30%"
					  :before-close="handleClose">
					    <audio :src='music1' autoplay controls="controls"controlsList="nodownload" oncontextmenu="return false">
						 您的浏览器不支持 audio 标签。
					    </audio>
					</el-dialog>

					<!--播放视频-->
					<!-- <el-dialog
					  :visible.sync="music_dialogVisible"
					  top="30vh"
					  width="30%">
					    <audio :src='music1' controls="controls"controlsList="nodownload" oncontextmenu="return false">
						 您的浏览器不支持 audio 标签。
					    </audio>
					</el-dialog> -->
					<div class="v_model" v-show="v_show">
						<div id="myVideo"></div>
						<span @click="video_show">x</span>
					</div>

					<!--QQ浏览器-->
					<div class="b_model" v-show="b_show">
						<div class="b_box">
							<div class="head">获取用户权限</div>
							<span @click="browser_close">x</span>
							<div class="content">
								您暂未获取视频观看权限，
								请先安装QQ浏览器，并设置成默认浏览器
								然后点击下方下载按钮，将其保存在您的电脑上。双击运行将打开您的QQ浏览器。
								用此浏览器重新进入系统。
							</div>
							<button class="download">
								<a href="https://crm.gymbaby.org/Jiaoanh/xiazai">下载</a>
							</button>
						</div>
					</div>

					<!--验证码-->
					<div class="code_model" v-show="code_show">
						<div class="code_box">
							<div class="head">请输入验证码</div>
							<span @click="code_show = false">x</span>
							<label>验证码：</label>
							<input type="text" v-model="code_val" />
							<div class="foot">
								<button class="btn" @click="confirm_btn" style="margin-left: 110px;">确定</button>
								<button class="btn" @click="code_show = false" style="margin-left: 20px;">取消</button>
							</div>
						</div>
					</div>
			    </el-col>
			</el-row>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
                tab_index:0,//tab切换
           	    token:'',
			    left_title:[],//侧边栏导航
			    list_fen:[],
			    list_zong:[],
			    b_show:false,//QQ浏览器
			    code_show:false,//验证码
			    code_val:'',
			    v_id:'',//视频ID
			    play_auth:'',
			    shipp:'',
			    player:'',
			    v_show:false,//视频
				music_dialogVisible:false,//音乐播放器
				music1:'',
			};
		},
		mounted(){
			let self = this
            self.token=self.$cookies.get('token');
        	$.ajax({
				  url: process.env.apiUrl + 'saas/Jiaoanh/zhuti',
				  type: 'post',
				  data:{
				  	 token:self.token
				  },
				  success: function (data, status) {
				  	  self.left_title=data
				  },
				  fail: function (err, status) {
				     console.log(err)
				  }
			})

        	//默认数据
        	$.ajax({
				  url: process.env.apiUrl + 'saas/Jiaoanh/deta',
				  type: 'post',
				  data:{
				  	 id:1,
				  	 token:self.token
				  },
				  success: function (data, status) {
				  	  self.list_fen=data.fen
				  	  self.list_zong=data.zong
				  },
				  fail: function (err, status) {
				     console.log(err)
				  }
			})
		},
		methods: {
			play_music(m){
				if(m == ''){
					this.$message.error('暂无音乐')
				}else{
					this.music1 = m
					this.music_dialogVisible = true
				}
			},
			video_show(){
				this.v_show = false;
                if(self.player){
                    self.player.dispose();
                }
                $('#myVideo').empty();
			},
			handleClose(){
				this.music_dialogVisible = false
				this.music1 = ""
			},
			//tab切换
            tabbar(index,id){
            	this.tab_index = index

                let self = this
	        	$.ajax({
					  url: process.env.apiUrl + 'saas/Jiaoanh/deta',
					  type: 'post',
					  data:{
					  	 id:id,
					  	 token:self.token
					  },
					  success: function (data, status) {
					  	  self.list_fen=data.fen
					  	  self.list_zong=data.zong
					  },
					  fail: function (err, status) {
					     console.log(err)
					  }
				})
            },
            //QQ浏览器
            browser_close(){
            	this.b_show = false
            },
            //播放视频
            play_video(id){
            	this.v_id=id
            	this.code_val = ''

            	this.v_show=true

                let self = this
	        	$.ajax({
					  url: process.env.apiUrl + 'saas/Jiaoanh/pdm',
					  type: 'post',
					  data:{
					  	 token:self.token
					  },
					  success: function (data, status) {
					  	  if(data == 1){
					  	  	self.b_show = true
					  	  }else if(data == 2){
					  	  	self.code_show = true
					  	  }else if(data == 3){
					  	  	alert('此视频只能在最初绑定的电脑播放')
					  	  }else if(data == 4){
					  	  	self.confirm_btn()
					  	  }



					  },
					  fail: function (err, status) {
					     console.log(err)
					  }
				})
           },
            //验证码
            confirm_btn(){
            	let self = this
	        	$.ajax({
					  url: process.env.apiUrl + 'saas/Jiaoanh/getplayauth',
					  type: 'post',
					  data:{
					  	 token:self.token,
					  	 vid:self.v_id,
					  	 yzm:self.code_val
					  },
					  success: function (data, status) {
//					  	 if(data == 1){
//					  	 	self.code_show=false
//					  	 	window.location.href='https://crm.gymbaby.org/Jiaoanh/xiazai'
//					  	 }
                          self.play_auth=data.play_auth;
                          self.shipp=data.vid;

                          if(self.player){
                              self.player.dispose();
                          }

                          setTimeout(function () {
                              self.player = Aliplayer(
                                  {id: "myVideo",
                                      autoplay: true,
                                      width: "818px",
                                      height: "460px",
                                      vid: self.shipp,
                                      playauth: self.play_auth
                                  });
                          },10)
					  },
					  fail: function (err, status) {
					     console.log(err)
					  }
				})
            }
		}
//		    methods: {
//		        denglu:function () {
//		            this.$cookies.set("token",true,"16h")
//		            //this.$store.commit('changeLogin','100')
//		            this.$router.push({ path: 'home' })
//		        }
//		    }
	}
</script>

</style>



// WEBPACK FOOTER //
// src/pages/huiben/huiben.vue